import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Popconfirm, Space, Table, Tag, Typography } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../../components/ui/SearchInput';
import { deleteUser, getUsers } from '../../redux/actions/users';
import { getRoutes } from '../../routes/Routes';
import { getRoleByValue } from '../../utils';

const Users = () => {
    const navigate = useNavigate();
    const { users } = useSelector((state) => state.usersSlice);

    const columns = [
        {
            title: 'Netsuite ID',
            dataIndex: 'netsuite_id',
            key: 'netsuite_id',
        },
        {
            title: 'Name',
            key: 'name',
            render: (_, record) => `${record.first_name} ${record?.last_name}`,
        },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        {
            title: 'Role',
            dataIndex: 'type',
            key: 'type',
            render: (type) => type && getRoleByValue(type),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                return (
                    <Tag className="inline-flex align-items-center gap-1" color={status ? 'green' : 'red'}>
                        <Badge color={status ? 'green' : 'red'} />
                        <span>{status ? 'Active' : 'Inactive'}</span>
                    </Tag>
                );
            },
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            align: 'end',
            render: (_, record) => (
                <Space size="small">
                    <Button
                        color="primary"
                        variant="filled"
                        icon={<EditOutlined />}
                        onClick={() => navigate(getRoutes().user_details.route(record.id))}
                    />
                    <Popconfirm
                        title="Are you sure to delete this user?"
                        description="This action cannot be undone."
                        okText="Yes, Delete"
                        cancelText="Cancel"
                        okType="danger"
                        onConfirm={() => deleteUser({ id: record.id })}
                    >
                        <Button color="danger" variant="filled" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const handleGetUsers = (searchText) => {
        const body = { searchText };
        getUsers(body);
    }

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <div className="user-page">
            <div className="page-header mb-3">
                <div className="flex justify-content-between align-items-center mb-2">
                    <Typography.Title level={3} className='page-title'>Users Management</Typography.Title>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => navigate(getRoutes().add_users.route())}
                    >
                        Add User
                    </Button>
                </div>

                <div className="flex align-items-center gap-2">
                    <SearchInput
                        placeholder="Search by name or email"
                        onSearch={handleGetUsers}
                    />
                </div>
            </div>

            <Table
                size="small"
                columns={columns}
                dataSource={users}
                rowKey={(record) => record?.id}
                scroll={{ x: 'max-content' }}
                pagination={false}
            />
        </div>
    );
};

export default Users;
